/* Publish by EComposer at 2026-09-26 22:46:44*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xdcu5bfb5uq"]=  window.__ectimmers["ecom-xdcu5bfb5uq"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",n),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",n),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-xdcu5bfb5uq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdcu5bfb5uq', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}